export default {"src":"https://images-cdn.curipod.com/d-d0a8b2df/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};